__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-10-06-1791294400-stable-dev/";